import React from 'react';
import FlatGroup, { FieldGroup, TabGroup } from './Group';
import { InputField, INPUT_TYPE } from './InputField';

export default class UIObject {
    originData: any;
    outputData: any;
    // inputObject: any;
    view: string;
    hiddenFields: string[];
    lockedFields: string[];
    // inputFields: InputField[];
    sortedFields: InputField[];
    groups: FieldGroup[] | undefined;
    onDataChanged?: (data: any) => void;
    onSubmit?: (values: any) => void;

    constructor(data: any) {
        this.originData = data ? { ...data } : {};
        this.outputData = data ? { ...data } : {};
        // this.inputObject = {}
        this.hiddenFields = [];
        this.lockedFields = [];
        // this.inputFields = [];
        this.sortedFields = [];
        this.groups = []
        this.view = data.view;

        if (typeof data === 'object') {
            Object.keys(data).map((key) => {
                const field = new InputField({ key: key, value: data[key] })
                this.sortedFields.push(field)
                // console.log("ADD new field: ", field)
            })
        }
        console.log("START MAPPING DATA", data)
        this.mapData()
        console.log("END CONSTRUCTURE UI_OBJECT")
    }

    addLockedField = (field: string) => {
        if (!this.lockedFields.includes(field)) {
            this.lockedFields.push(field);
            this.mapData();
        }
    }

    unlockField = (field: string) => {
        if (this.lockedFields.includes(field)) {
            this.lockedFields = this.lockedFields.filter(function (ele) { return ele != field; });
            this.mapData();
        }
    }

    addHiddenField = (field: string) => {
        if (!this.hiddenFields.includes(field)) {
            this.hiddenFields.push(field);
            this.mapData();
        }
    }

    unHideField = (field: string) => {
        if (this.hiddenFields.includes(field)) {
            this.hiddenFields = this.hiddenFields.filter(function (ele) { return ele != field; });
            this.mapData();
        }
    }

    updateFieldProperties(field: InputField, fieldIndex?: number) {
        if (!Array.isArray(this.sortedFields))
            this.sortedFields = [];
        let existedFieldIndex = this.sortedFields.findIndex(f => f.key === field.key)
        // console.log("====CURRENT FIELD====", field)
        if (existedFieldIndex != -1) {
            if (fieldIndex != undefined && fieldIndex >= 0 && fieldIndex <= this.sortedFields.length && fieldIndex != existedFieldIndex) {
                this.sortedFields.splice(existedFieldIndex, 1);
                this.sortedFields.splice(fieldIndex, 0, field)
            } else
                this.sortedFields[existedFieldIndex] = field
        } else if (fieldIndex!=undefined && fieldIndex>=0 && fieldIndex<this.sortedFields.length) {
            //found nearest previous index availble
            this.sortedFields.splice(fieldIndex, 0, field)
        } else {
            this.sortedFields.push(field)
        }
    }

    convertFieldToSelect(fieldKey: string, options: Array<any>) {
        if (!Array.isArray(this.sortedFields))
            this.sortedFields = [];
        let existedFieldIndex = this.sortedFields.findIndex(f => f.key === fieldKey)
        if (existedFieldIndex != -1) {
                this.sortedFields[existedFieldIndex].convertToSelect(options);
        }
    }

    addField(field: InputField, fieldIndex?: number) {
        if (!Array.isArray(this.sortedFields))
            this.sortedFields = [];

        if (!fieldIndex || fieldIndex > this.sortedFields.length)
            this.sortedFields.push(field)
        else if (fieldIndex >= 0 && fieldIndex <= this.sortedFields.length)
            this.sortedFields.splice(fieldIndex, 0, field)
    }

    getOriginData = () => {
        return this.originData;
    }

    mapData = () => {
        if (typeof this.originData != 'object') {
            // console.log("======= SORTED FIELD: ", this.originData)
            this.sortedFields = [new InputField(this.originData)];
        } else {
            this.sortedFields.map((field: InputField) => {
                field.onDataChanged = this.onChangeKeyValue
                if (this.hiddenFields.findIndex(f => f === field.key) != -1) {
                    field.inputType = INPUT_TYPE.HIDDEN
                    field.isHidden = true;
                }
                if (this.lockedFields.findIndex(l => l === field.key) != -1) {
                    // field.inputType = INPUT_TYPE.LOCKED
                    field.editable = false
                    field.addProp('disabled', true)
                }

                // console.log("SORTED FIELD: ", field)
            });
            // console.log("ALL SORTED FIELDS: ", this.sortedFields)
        }
    }

    revert = () => {
        this.outputData = { ...this.originData };
    }

    onChangeKeyValue = (fieldKey: any, value: any) => {
        this.outputData = { ...this.outputData, [fieldKey]: value }
        this.onDataChanged && this.onDataChanged(this.outputData)
    }

    data = () => {
        return this.outputData;
    }

    generateFormUI = () => {
        this.mapData()
        console.log("============ VIEW TYPE: ", this.sortedFields)
        return (
            <>
                {/* {this.groupView(this.groups, this.view === 'tab' ? 'tab' : 'flat')} */}
                {
                    this.sortedFields.map((item) => {
                        console.log("FIELD: ", item)
                        if (!item.group)
                            return item.generateUI()
                        else return null
                    })
                }
            </>
        )
    }

    groupView = (groups: any, viewType: string) => {
        switch (viewType) {
            case "tab": return <TabGroup groups={groups} fields={this.sortedFields} />
            default: return (<>
                {groups && Array.isArray(groups) && groups.length > 0
                    ? groups.map((group, index) => (
                        <FlatGroup group={group} key={index}>
                            {
                                this.sortedFields.map((item) => <>{item.group === group.groupId ? item.generateUI() : null}</>)
                            }
                        </FlatGroup>
                    ))
                    : null}
            </>);
        }
    }


}

// const mapInput = (dataObject: any, template: InputField[]) => {
//     if (typeof dataObject != 'object') {
//         return dataObject;
//     }
//     // console.log("Created new input object with template: ", template);
//     const output: any = {};
//     const mappedField:Array<string> = [];

//     template.map((field: InputField) => {
//         output[field.key] = field;
//     });

//     Object.keys(dataObject).map((key) => {
//         const fieldValue = dataObject[key];
//         const fieldTemplate = template.find(t=>t.key===key)
//         if (fieldTemplate && fieldTemplate instanceof InputField) {
//             if (typeof fieldValue === "object") {
//                 if (fieldTemplate.value instanceof Object) {
//                     // console.log("========== Template is Object: ", template[key].value);
//                     // console.log("========== fieldValue: ", fieldValue);
//                     if (Array.isArray(template.inputObject[key].value) && template.inputObject[key].inputType == INPUT_TYPE.CASCADER) {
//                         output[key] = template.inputObject[key];
//                         output[key].addProp("defaultValue", fieldValue);
//                     } else {
//                         output[key] = mapInput(fieldValue, template.inputObject[key].value);
//                         // console.log("========== New object UI: ", output[key]);
//                     }
//                 } else if (Array.isArray(fieldValue)) {
//                     output[key] = template.inputObject[key];
//                     output[key].addProp("defaultValue", fieldValue);
//                 } else {
//                     output[key] = new InputField({key:key, value:fieldValue});
//                     // console.log("New object UI (template is not array): ", output[key]);
//                 }
//             } else {
//                 output[key] = template.inputObject[key];
//                 output[key].addProp("defaultValue", fieldValue);
//                 // console.log("New input UI: ", output[key]);
//             }
//             mappedField.push(key);
//         } else {
//             // console.error("Template is invalid at Key: ", key);
//             output[key] = new InputField({key:key, value:fieldValue});
//         }
//     });

//     //create remain fields in Template, which is empty in origin data
//     Object.keys(template).map((key) => {
//         if (!mappedField.includes(key) && template && template.inputObject[key] && template.inputObject[key] instanceof InputField) {
//             output[key] = template.inputObject[key];
//         }
//     });

//     return output;
// };
